import { usePaymentPlace } from '@funtech-int/yango-shared';

import { PlusPaymentPlace } from '@/shared/constants/payments';
import { usePaymentPage } from '@/shared/hooks/usePaymentPage';

const MULTI_OFFER_PLACES: PlusPaymentPlace[] = [
    PlusPaymentPlace.PaywallBaseOfferButton,
    PlusPaymentPlace.PaywallExtraOfferButton,
];

export const useMultiOffers = () => {
    const page = usePaymentPage();
    const paymentPlace = usePaymentPlace({ page, places: MULTI_OFFER_PLACES });

    const isFallbackOffer = paymentPlace.offers?.length === 1;

    return {
        isFallbackOffer,
        forcedPlace: isFallbackOffer
            ? (paymentPlace.offers?.[0]?.place as PlusPaymentPlace)
            : undefined,
        paymentPlace,
    };
};
